import { render, staticRenderFns } from "./V2Checkbox.vue?vue&type=template&id=18c7dda9&scoped=true&"
import script from "./V2Checkbox.vue?vue&type=script&lang=js&"
export * from "./V2Checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c7dda9",
  null
  
)

export default component.exports